const WodaListaWspolnot = props => {

    const {wspolnoty, wybranaWspolnota, setWybranaWspolnota} = props;

    const lista = wspolnoty.map( (b,i) => {
        return (
            <option
                key={i}
                value={b.id}
            >
                {`${b.name} (${b.id})`}
            </option>
        )
    });

    const handleChange = e  => {
        const id = e.target.value;
        const wspolnota = wspolnoty?.find( w => w?.id == id);
        setWybranaWspolnota( wspolnota );
    }

    return (
        <div 
            className='woda-lista-wspolnot'
        >
            <select
                value={wybranaWspolnota?.id}
                onChange={handleChange}
            >
                <option key={0} value={0}>
                    Wybierz:
                </option>
                { lista }
            </select>
        </div>
    )
}

export default WodaListaWspolnot;